import { AnalyticsService } from './../analytics/analytics.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { Contribution, ThankYouCampaign } from '../track/contribution';
import { ActivatedRoute, Router } from '@angular/router';
import { RegistryService } from '../registry/registry.service';
import { AuthService, User } from '../user/auth.service';
import { RegistryFirebaseService } from '../registry/registry-firebase.service';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { PaymentService } from '../payment/payment.service';
import { TrackedGiftCollection } from '../payment/tracked-gift-collection';
import { TrackedGift } from '../payment/tracked-gift';
import { SettingsService } from '../settings/settings.service';
import { Registry } from '../registry/registry';
import { environment } from '../../environments/environment';
import { PersonalTempCreateModeComponent } from '../personal-temp-createmode/personal-temp-createmode.component';
import { GuestCardRequest } from './guest-card';

declare var Stripe;

@Component({
  selector: 'app-guest-detail',
  templateUrl: './guest-cards.component.html',
  styleUrls: ['./guest-cards.component.scss']
})
export class GuestCardsComponent implements OnInit, AfterViewInit {
  prices: any[];
  pricePerCard: number;
  public hitchdForm: FormGroup;
  loading = true;
  errorMessage: string;
  selectedQty: number;
  design: string;
  anonymousId: string;
  guestCardRequest: GuestCardRequest;
  thankType: string;
  digitalThankYouMsg: string;
  contributions: Contribution[];
  symbol: string;
  isSendMode = false;
  invalidDigitalCardMsg = false;
  processing = false;
  currency: string;
  faq = false;
  greeting: string;
  artworkId: string;
  loaded = false;
  mode: string;
  sentDate: Date;
  maxDate: Date;
  registryName: string;
  guestCheckoutId : string;
  minDate: Date
  designs = [
    {
      'url': '/assets/public/images/cards/c202b5ff-747d-5f21-a853-a9ff57deda1b.jpg',
      'id': 'c202b5ff-747d-5f21-a853-a9ff57deda1b',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/0ffa39d9-08f6-b8c0-2362-e4df2eaf4ac9.jpg',
      'id': '0ffa39d9-08f6-b8c0-2362-e4df2eaf4ac9',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/ac7c8641-70b4-772a-8868-086a62abf374.jpg',
      'id': 'ac7c8641-70b4-772a-8868-086a62abf374',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/6ac9176f-08fd-9d42-ee3f-ec8dd00b56a8.jpg',
      'id': '6ac9176f-08fd-9d42-ee3f-ec8dd00b56a8',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/0495a791-2031-1312-6d00-39f2cb61f9ca.jpg',
      'id': '0495a791-2031-1312-6d00-39f2cb61f9ca',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/be7c218c-03c8-4964-6d40-724545cfbc2d.jpg',
      'id': 'be7c218c-03c8-4964-6d40-724545cfbc2d',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/bf232592-c85e-5cd6-7aa9-af677e3f84b0.jpg',
      'id': 'bf232592-c85e-5cd6-7aa9-af677e3f84b0',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/4e35f4e6-f148-f834-b8d0-16fc46f04cd5.jpg',
      'id': '4e35f4e6-f148-f834-b8d0-16fc46f04cd5',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/ac30e519-3a84-9d7f-9455-db2654033564.jpg',
      'id': 'ac30e519-3a84-9d7f-9455-db2654033564',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/fcec13c2-8fc8-8363-e356-3e0005fcff94.jpg',
      'id': 'fcec13c2-8fc8-8363-e356-3e0005fcff94',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/40682774-ffbc-5284-5c8e-dc760f03eb4c.jpg',
      'id': '40682774-ffbc-5284-5c8e-dc760f03eb4c',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/b233e8b0-a712-2cfb-31ef-61717f8ba1c3.jpg',
      'id': 'b233e8b0-a712-2cfb-31ef-61717f8ba1c3',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/a5a30071-a139-4f04-2e1a-0794b3f82989.jpg',
      'id': 'a5a30071-a139-4f04-2e1a-0794b3f82989',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/96da8c51-ede5-038f-2291-2fc3f08ccec6.jpg',
      'id': '96da8c51-ede5-038f-2291-2fc3f08ccec6',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/5121bf60-ba03-f6c1-85b1-edc93ae661ba.jpg',
      'id': '5121bf60-ba03-f6c1-85b1-edc93ae661ba',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/5de575ba-c9cf-5a12-21fb-2e1ec73837fc.jpg',
      'id': '5de575ba-c9cf-5a12-21fb-2e1ec73837fc',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/83b385e8-ec27-3615-3fa5-b87acce7a717.jpg',
      'id': '83b385e8-ec27-3615-3fa5-b87acce7a717',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/56dd1245-ac76-3996-a65d-2bf54b034384.jpg',
      'id': '56dd1245-ac76-3996-a65d-2bf54b034384',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/e974997d-fa6e-f4d9-e458-93b9b48d0353.jpg',
      'id': 'e974997d-fa6e-f4d9-e458-93b9b48d0353',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/80f5c199-98f3-f00a-4deb-8c6127ef330b.jpg',
      'id': '80f5c199-98f3-f00a-4deb-8c6127ef330b',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/ce74715a-2ba7-e822-6711-7749a4a5132c.jpg',
      'id': 'ce74715a-2ba7-e822-6711-7749a4a5132c',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/1363f6a5-5c97-528d-de1f-b3d71a2fbcbf.jpg',
      'id': '1363f6a5-5c97-528d-de1f-b3d71a2fbcbf',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/47f283e5-3f67-7f24-5977-b1436a5ee8f4.jpg',
      'id': '47f283e5-3f67-7f24-5977-b1436a5ee8f4',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/7c5ff46f-2ab2-3eb4-5945-fa8db54f5062.jpg',
      'id': '7c5ff46f-2ab2-3eb4-5945-fa8db54f5062',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/b6036ec9-132f-d86a-f429-d156220577ab.jpg',
      'id': 'b6036ec9-132f-d86a-f429-d156220577ab',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/e34af83f-f9ad-695b-616a-29b2961c0d9a.jpg',
      'id': 'e34af83f-f9ad-695b-616a-29b2961c0d9a',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/090b25ac-24cf-6854-b25d-8679aa9994fe.jpg',
      'id': '090b25ac-24cf-6854-b25d-8679aa9994fe',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/8cd1f392-b946-1916-3982-0783026ad251.jpg',
      'id': '8cd1f392-b946-1916-3982-0783026ad251',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/169ecc7d-2be9-40c3-c1b8-c5af9a72de1e.jpg',
      'id': '169ecc7d-2be9-40c3-c1b8-c5af9a72de1e',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/a46823b5-d98f-91fe-1a42-dd5d0d6116a5.jpg',
      'id': 'a46823b5-d98f-91fe-1a42-dd5d0d6116a5',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/c286b589-1ff9-3156-7de0-1d5299162cf0.jpg',
      'id': 'c286b589-1ff9-3156-7de0-1d5299162cf0',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/e929e5ee-a42c-a03e-4896-606f40a550af.jpg',
      'id': 'e929e5ee-a42c-a03e-4896-606f40a550af',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/68c398b9-3fe1-4b80-7767-319dc72d538b.jpg',
      'id': '68c398b9-3fe1-4b80-7767-319dc72d538b',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/50c889da-8dc2-e97a-1a27-8171becd11a4.jpg',
      'id': '50c889da-8dc2-e97a-1a27-8171becd11a4',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/b7b5f42e-f52d-2080-42b3-36518425fa52.jpg',
      'id': 'b7b5f42e-f52d-2080-42b3-36518425fa52',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/ba5ccad8-b049-30c7-aa0c-01307f2e69a5.jpg',
      'id': 'ba5ccad8-b049-30c7-aa0c-01307f2e69a5',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/eb26dbd5-2323-52a1-1884-5c0ac1640607.jpg',
      'id': 'eb26dbd5-2323-52a1-1884-5c0ac1640607',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/826ec5cd-a0fa-7a39-9d46-aee5f6ddd0a3.jpg',
      'id': '826ec5cd-a0fa-7a39-9d46-aee5f6ddd0a3',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/7947c4d7-8bb9-da1d-6ee8-d5a96eb3c680.jpg',
      'id': '7947c4d7-8bb9-da1d-6ee8-d5a96eb3c680',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/cd8ea2a1-b966-880c-7f2a-760dacf9fd08.jpg',
      'id': 'cd8ea2a1-b966-880c-7f2a-760dacf9fd08',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/42ffa779-fdbf-d28d-6668-39c0d72f60c1.jpg',
      'id': '42ffa779-fdbf-d28d-6668-39c0d72f60c1',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/a2a677bc-b631-fd22-b8e2-4f0d4c050f06.jpg',
      'id': 'a2a677bc-b631-fd22-b8e2-4f0d4c050f06',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/cd36e75a-2be9-530b-7a06-951333a39531.jpg',
      'id': 'cd36e75a-2be9-530b-7a06-951333a39531',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/8e48423a-193c-ffa7-3aca-a2259a993255.jpg',
      'id': '8e48423a-193c-ffa7-3aca-a2259a993255',
      'type': 'Landscape Card'
    },
    {
      'url': '/assets/public/images/cards/d1e285ae-c3df-297f-0223-09f87bb17ae9.jpg',
      'id': 'd1e285ae-c3df-297f-0223-09f87bb17ae9',
      'type': 'Landscape Card'
    },






















  ]
  euCountries = [
    'AL',
    'AD',
    'AM',
    'AT',
    'BY',
    'BE',
    'BA',
    'BG',
    'CH',
    'CY',
    'CZ',
    'DE',
    'DK',
    'EE',
    'ES',
    'FO',
    'FI',
    'FR',
    'GB',
    'GE',
    'GI',
    'GR',
    'HU',
    'HR',
    'IE',
    'IS',
    'IT',
    'LT',
    'LU',
    'LV',
    'MC',
    'MK',
    'MT',
    'NO',
    'NL',
    'PO',
    'PT',
    'RO',
    'RU',
    'SE',
    'SI',
    'SK',
    'TR',
    'UA',
    'VA'
  ];
  price: number;
  step = 1;
  sends: any[];
  thankYouCampaign: ThankYouCampaign;
  type: string;
  cardsLeft: number;
  selectedPackage: number;
  contributionId: string;
  bundle: string;
  contribution: Contribution;
  uploadedImage: string;  
  registry: Registry;
  uploadText = 'Upload image from your trip';
  country: string;
  isEu: boolean;
  sendThankYouMsg: string;
  currentPrice: number;
  errors: string;
  yourErrors: string;
  tempCardMessage: string;

  pricingPerCard: any =

  {
    AU: { country: 'AU', price_per_card: 18 },
    GB: { country: 'GB', price_per_card: 12 },
    US: { country: 'US', price_per_card: 12 },
    CA: { country: 'CA', price_per_card: 12 },
    NZ: { country: 'NZ', price_per_card: 12 },
    EU: { country: 'DE', price_per_card: 10 },
  };
  frontImageUrl: any;

  constructor(
    private _registryFirebaseService: RegistryFirebaseService,
    private _authService: AuthService,
    private _registryService: RegistryService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _fb: FormBuilder,
    private _paymentService: PaymentService,
    private _analyticsService: AnalyticsService,
    private route: ActivatedRoute,
  ) {

    document.title = 'Send a Card | Hitchd';
    







  }

  shouldSetAsEuForPayment() {
    if (this.country == 'CH' || this.country == 'NO' || this.country == 'SE') {
      this.country = "EU"
      this.isEu = true;
      this.symbol = "€";
    }
  }
  getDetails() {
    return fetch(environment.firebase.clouldFunctionHost + '/getDetailWish?id=' + this.contributionId +"&anonymousId="+this.anonymousId, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    })
      .then(response => response.json())
      .then(data => {

        console.log(data.guestCardArtworkId);
        this.guestCardRequest = data as GuestCardRequest;
        
        this.sendThankYouMsg = this.guestCardRequest.guestWish;
        this.country = this.guestCardRequest.country;
        this.currency = this.guestCardRequest.currency;
        this.symbol = this.guestCardRequest.symbol;
        this.loading = false;
        this.killAppLoader();
        this.guestCheckoutId = data.guestCheckoutId;
        this.artworkId = data.guestCardArtworkId;
        this.frontImageUrl = data.guestCardFrontImageUrl;

        this._analyticsService.setAnonymousId(this.guestCardRequest.guestEmail);
        this._analyticsService.identifyAnonymousUser({
          email: this.guestCardRequest.guestEmail,
          name: this.guestCardRequest.guestName,
          is_guest: true,
          country: this.guestCardRequest.country,
          currency: this.guestCardRequest.currency
        })


        this.hitchdForm.controls['firstName'].setValue(this.guestCardRequest.coupleFirstName + " and " + this.guestCardRequest.couplePartnerFirstName)
        // this.hitchdForm.controls['lastName'].setValue()
        this.hitchdForm.controls['country'].setValue(this.guestCardRequest.country)
        this.hitchdForm.controls['yourCountry'].setValue(this.guestCardRequest.country)


        if (this.guestCardRequest.guestName) {

        //  this.hitchdForm.controls['yourFirstName'].setValue(this.guestCardRequest.guestName)
          let names = this.guestCardRequest.guestName.split(' ');

          if (names && names.length >= 1) {

            let lastname = this.guestCardRequest.guestName.replace(names[0], '');

            this.hitchdForm.controls['yourFirstName'].setValue(names[0])
            this.hitchdForm.controls['yourLastName'].setValue(lastname)
          }
        }


        this.initPrices();
        if (this.guestCardRequest.guestPhysicalCardPurchased && !this.guestCardRequest.guestPhysicalCardSent && !this.isSendMode) {
          this._router.navigateByUrl("/" + this.registryName + "/wellwishes/" + this.contributionId + "/send")
        } else if (this.guestCardRequest.guestPhysicalCardPurchased && !this.guestCardRequest.guestPhysicalCardSent && this.isSendMode) {
          this.step = 3;
          this.mode = "cards";

        } else if (this.guestCardRequest.guestPhysicalCardSent){
          this.sentDate = new Date(data.sentDate);
          this.maxDate = new Date(data.maxDate);
          this.minDate = new Date(data.minDate);
          this.step = 4;
          this.mode = "cards";
        }
      });

    //     .then((result) => {
    // ;


    //     });
  }
  close(){
    this._router.navigateByUrl("/" + this.registryName + "/wellwishes/" + this.contributionId )
  }

  analyticsTrack(event) {
    this._analyticsService.trackEvent(event, {});
  }

  clearIfEmpty(fieldName: string) {
    const field = this.hitchdForm.controls[fieldName];
    field.setValue('');
  }
  focusOut(fieldName: string, resetValue: string) {
    const field = this.hitchdForm.controls[fieldName];

  }

  next(step: number) {


    if (!this.cardsLeft && this.sendThankYouMsg) {
      localStorage.setItem('last-card_' + this.contributionId, this.sendThankYouMsg);
    }
    let analyticsEventName = '';
    if (step === 1) {
      this.loading = false;
      this.killAppLoader();
      analyticsEventName = 'Guest Wedding card - design selected';
    } else if (step === 2) {
      analyticsEventName = 'Guest Wedding card - message entered';
    } else if (step === 3 && !this.faq && this.cardsLeft === 0) {
      
    }
    this._analyticsService.trackEvent(analyticsEventName, { contributionId: this.contributionId });


    this.step = step;
  }

  expandTextArea(textArea: HTMLTextAreaElement) {
    textArea.rows = 1;
    const height = textArea.scrollHeight;
    textArea.rows = Math.floor(height / 26); // 20px = line-height: 1.25rem
    this.hitchdForm.markAsTouched();
  }


  thankYou(thankYouText: string, thankYouImageUrl: string) {
    this._registryFirebaseService.updateContribution(this.contributionId, thankYouText, thankYouImageUrl, true, false);

  }

  ngAfterViewInit(): void {
    window.scrollTo(0, 0);
    const textarea: HTMLTextAreaElement = <HTMLTextAreaElement>document.getElementById('introtext');
    //
    if (textarea) {
      textarea.value = textarea.value + '';
      this.expandTextArea(textarea);
    }

  }
  navigateToGift(url) {
    this._router.navigate(['/registry/' + url]
      , { queryParams: { from: 'contrib-detail' } });
  }
  handledUploadedImage(event: any) {
    if (event) {
      event = event + '?hex=ffffff';
    }
    this.uploadedImage = event;
  }

  getGiftUrlWithoutHex(imageUrl: string) {
    if (imageUrl) {
      return this._registryService.cleanImageUrlRemoveHex(imageUrl);
    }
  }

  color(imageUrl: string) {
    return this._registryService.getColor(imageUrl);
  }


  openUploader() {

    document.getElementById('file_input_id').click();
  }

  selectFirstName(fullName: string) {

    if (fullName) {
      return fullName.split(' ')[0];
    }
  }

  sendThanksViaCard() {
    if (!this.registry.paidThankyouCards || this.registry.availableThankYouCards == 0) {
      this._router.navigate(['/registry/thank-you-cards'])
    }
  }



  isEuCountry(country) {
    return this.euCountries.includes(country);
  }


  initPrices() {

    this.isEu = this.isEuCountry(this.country);

    this.shouldSetAsEuForPayment();
    let priceObjectPerCard = this.pricingPerCard[this.country];
    if (!priceObjectPerCard && this.isEu) {
      priceObjectPerCard = this.pricingPerCard['EU'];
    } else if (!priceObjectPerCard && !this.isEu) {
      priceObjectPerCard = this.pricingPerCard['US'];
    }
    this.pricePerCard = priceObjectPerCard.price_per_card;

    this.prices = [
      { price: this.pricePerCard * 1, qty: 1 },
      { price: this.pricePerCard * 2, qty: 2 },
      { price: this.pricePerCard * 3, qty: 3 },
      { price: this.pricePerCard * 4, qty: 4 },
      { price: this.pricePerCard * 5, qty: 5 },
      { price: this.pricePerCard * 10, qty: 10 },
      { price: this.pricePerCard * 15, qty: 15 },
      { price: this.pricePerCard * 20, qty: 20 },
      { price: this.pricePerCard * 25, qty: 25 },
      { price: this.pricePerCard * 30, qty: 30 },
      { price: this.pricePerCard * 35, qty: 35 },
      { price: this.pricePerCard * 40, qty: 40 },
      { price: this.pricePerCard * 45, qty: 45 },
      { price: this.pricePerCard * 50, qty: 50 },
      { price: this.pricePerCard * 60, qty: 60 },
    ]
  }

  ngOnInit() {
    this.registry = this.route.snapshot.data.registry;
    this.isSendMode = location.pathname.includes('/send');
    
    this.route.params.subscribe(params => {
      this.contributionId = params['contributionId'];
      this.registryName = params['registry'];
      
      if (this.contributionId) {
        this.anonymousId = this._analyticsService.getAnonymousId();
        this.getDetails();
      }
    });




    this.hitchdForm = this._fb.group({
      firstName: [null, [Validators.required]],
      lastName: [' ', [Validators.required]],
      addressLine1: [null, [Validators.required]],
      city: [null, [Validators.required]],
      postcode: [null, [Validators.required]],
      state: [null, [Validators.required]],
      country: [null, [Validators.required]],

      yourFirstName: [null, [Validators.required]],
      yourLastName: [null, [Validators.required]],
      yourAddressLine1: [null, [Validators.required]],
      yourCity: [null, [Validators.required]],
      yourPostcode: [null, [Validators.required]],
      yourState: [null, [Validators.required]],
      yourCountry: [null, [Validators.required]],

    });





    
    //this._analyticsService.trackEvent('Guest Wedding card - page viewed', {});

  }
  selectPackage(bundle: string) {

    this.bundle = bundle;
    this.price = this.currentPrice[bundle];
    this._analyticsService.trackEvent('Guest Wedding card - bundle selected', {
      contributionId: this.contributionId,
      bundle: bundle, price: this.price, currency: this.registry.currency, country: this.registry.country
    });

  }
  setDesign(design: any) {

    this.frontImageUrl = design.url;
    this.artworkId = design.id;
    this.loading = false;
    this.killAppLoader();
    this._analyticsService.trackEvent('Guest Wedding card - design selected', {
      artworkId: this.artworkId,
      frontImageUrl: this.frontImageUrl
    });
  }

  killAppLoader(){
    const loader = document.getElementById('reg-loader');
    if (loader) {
      loader.remove();
    }
  }

  purchasePackage() {
    this.upgradeAccount();

  }


  hideFaq() {
    this._analyticsService.trackEvent('Guest Wedding card - faqs closed', { contributionId: this.contributionId });
    this.faq = false;
  }
  showFaq() {
    this._analyticsService.trackEvent('Guest Wedding card - show faqs clicked', { contributionId: this.contributionId });
    this.faq = true;
  }
  submit() {
    if (this.digitalThankYouMsg) {
      this.processing = true;
      const message = this.digitalThankYouMsg;
      const paymentId = this.contributionId;
      this._registryFirebaseService.updateContribution(paymentId, message, this.uploadedImage, true, false);

      let guestName = this.contribution.guestName;
      if (this.contribution.wish && this.contribution.wish.fullname) {

        guestName = this.contribution.wish.fullname;
        if (this.contribution.wish.partnersName) {
          guestName = this.selectFirstName(this.contribution.wish.fullname) + ' & '
            + this.selectFirstName(this.contribution.wish.partnersName);
        }

      }


      let giftNames = '';
      for (let i = 0, len = this.contribution.cart.length; i < len; i++) {
        if (giftNames !== '' && i < (len - 1)) {
          giftNames = giftNames + ', ';
        } else if (len > 1 && i === (len - 1)) {
          giftNames = giftNames + ' and ';
        }
        giftNames = giftNames + this.contribution.cart[i].gift.title;
      }


      const emailRequest: any = {
        registryId: this.registry.id,
        giftNames: giftNames,
        guestNames: guestName,
        thankyouText: message,
        thankyouImage: this.uploadedImage,
        giftTotal: this.contribution.giftTotal,
        coupleNames: this.registry.firstName + ' & ' + this.registry.partnerFirstName,
        guestEmail: this.contribution.guestEmail,
        totalAmount: this.contribution.giftTotal + this.contribution.guestFee,
        guestFee: this.contribution.guestFee,
        symbol: this.registry.symbol
      };
      this._paymentService.SendThankYouEmail(JSON.stringify(emailRequest)).subscribe(x => {
        this._router.navigate(['/registry/contributions', this.contributionId]);
      });
    }

  }
  modelChanged(newObj) {
    // do something with new value
    const textarea = document.getElementById('thankyoudigital');

    this.fixedSize(textarea, null);
  }


  fixedSize(textarea, event) {



    if (textarea.clientHeight < textarea.scrollHeight) {
      this.invalidDigitalCardMsg = true;

    } else {
      this.invalidDigitalCardMsg = false;
    }
  }
  sendThankYouCard() {
console.log(this.artworkId)
    this._authService.authToken().subscribe(token => {
      this.yourErrors = null;
      this.errors = null;


      this.processing = true;
      return fetch(environment.firebase.clouldFunctionHost + '/sendGuestWeddingCard', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({         

          firstName: this.hitchdForm.controls['firstName'].value,
          lastName: this.hitchdForm.controls['lastName'].value,
          addressLine1: this.hitchdForm.controls['addressLine1'].value,
          city: this.hitchdForm.controls['city'].value,
          state: this.hitchdForm.controls['state'].value,
          postcode: this.hitchdForm.controls['postcode'].value,
          country: this.hitchdForm.controls['country'].value,
          yourFirstName: this.hitchdForm.controls['yourFirstName'].value,
          yourLastName: this.hitchdForm.controls['yourLastName'].value,
          yourAddressLine1: this.hitchdForm.controls['yourAddressLine1'].value,
          yourCity: this.hitchdForm.controls['yourCity'].value,
          yourState: this.hitchdForm.controls['yourState'].value,
          yourPostcode: this.hitchdForm.controls['yourPostcode'].value,
          yourCountry: this.hitchdForm.controls['yourCountry'].value,
          guestCardMessage: this.sendThankYouMsg,
          guestCardArtworkId:this.artworkId,
          guestCardFrontImageUrl:this.frontImageUrl,          
          contributionId: this.contributionId,      
          guestPaymentId: this.guestCheckoutId,    
          anonymousId: this.anonymousId
        }),
      }).then((result) => {


        if (result.status == 200) {
          result.json().then(resultData => {

            if (resultData.maxDate && resultData.minDate) {
              this.sentDate = new Date(resultData.sentDate);
              this.maxDate = new Date(resultData.maxDate);
              this.minDate = new Date(resultData.minDate);

            }
          });
          this.step = 4;





          if (this.tempCardMessage) {
            localStorage.removeItem('last-card_' + this.contributionId);
          }

        } else {
          this.processing = false;
          result.json().then((responseData) => {




            if (responseData && responseData.data && responseData.data["lines.0.recipient.region"]) {
              this.errors = responseData.data["lines.0.recipient.region"];
            }
            if (responseData && responseData.data && responseData.data["lines.0.sender.region"]) {
              this.yourErrors = responseData.data["lines.0.sender.region"];
            }





      
          })
        } 

      }).catch(ex => {
        this.processing = false;
        console.log(ex);
      });
    });
  }


  getDesigns() {




    return fetch(environment.firebase.clouldFunctionHost + '/getThankYouTemplates', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(response => response.json())
      .then(data => {
        this.designs = data;
        this.setDesign(this.designs[0]);

      });
  }

  upgradeAccount() {
    (window as any).stripe = Stripe(environment.stripePublicKey, {});

    let total = 1 * this.pricePerCard;

    //this.type = type;
    this.processing = true;
    return fetch(environment.firebase.clouldFunctionHost + '/createCheckoutSession', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        quantity: 1,
        total: total,
        userAgent: navigator.userAgent,
        url: location.href,
        locale: 'auto',
        guestCardMessage: this.sendThankYouMsg,
        guestCardArtworkId:this.artworkId,
        guestCardFrontImageUrl:this.frontImageUrl,
        country: this.country,
        contributionId: this.contributionId,
        isEu: this.isEu,
        email: this.guestCardRequest.guestEmail,
        type: 'cards_guest',
        registryUrl: this.registryName,
        paymentType: "cards_guest",
        anonymousId: this.anonymousId
      }),
    }).then((result) => {

      const reulst = result.json();
      reulst.then((x: any) => {
        const sessionId = x.sessionId;
        (window as any).stripe.redirectToCheckout({
          // Make the id field from the Checkout Session creation API response
          // available to this file, so you can provide it as parameter here
          // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
          sessionId: sessionId
        }).then(function (redirectResult) {
          // If `redirectToCheckout` fails due to a browser or network
          // error, display the localized error message to your customer
          // using `result.error.message`.
        });
        //  return redirectResult.json();
      });


    }
    );
    //

  }


}




// WEBPACK FOOTER //
// ./src/app/guest-cards/guest-cards.component.ts